import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var CommonNav =
/** @class */
function (_super) {
  __extends(CommonNav, _super);

  function CommonNav() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 点击
   */


  CommonNav.prototype.onClick = function (item) {
    this.$emit('input', item.value);
  };

  __decorate([Prop({
    required: true
  })], CommonNav.prototype, "value", void 0);

  __decorate([Prop({
    required: true,
    type: Array
  })], CommonNav.prototype, "navigations", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": true
  })], CommonNav.prototype, "autoWidth", void 0);

  CommonNav = __decorate([Component({
    name: 'CommonNav'
  })], CommonNav);
  return CommonNav;
}(Vue);

export default CommonNav;